<div class="container pb-3" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
	<div class="d-flex align-items-center py-2">
		<h6 class="pt-2 header-title" style="flex: 1">{{ locale.translations['ads']['qrcode']['n407'] }}</h6>

		<img
			class="scanner"
			(click)="onClose()"
			[routerLink]="['/barcode-scanner']"
			[ngClass]="{ closeLTR: locale.lang === 'en', closeRTL: locale.lang !== 'en' }"
			[src]="'assets/images/scanner.svg' | s3Image"
			alt="scanner"
		/>

		<button mat-icon-button [ngClass]="{ closeLTR: locale.lang === 'en', closeRTL: locale.lang !== 'en' }" (click)="onClose()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-divider></mat-divider>

	<div class="text-center p-4">
		<!-- <div class="container"></div> -->
		<span class="user_img cursor-pointer">
			<img tabindex="0" src="{{ data.image[0].name }}" />
		</span>

		<div class="mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone text-center svg-outer">
			<span class="title-text">{{ data.title }}</span>

			<div class="svg-cont mx-auto">
				<img src="{{ data.qrCode }}" alt="qrcode" />
			</div>
		</div>
	</div>

	<p class="text-center mb-3 barcode-view-more">{{ locale.translations['ads']['qrcode']['n411'] }}</p>

	<div class="d-flex justify-content-around social-btn-cont mx-auto">
		<button mat-button class="px-2 px-sm-4 dialog-btn" (click)="shareQrCode()" *ngIf="!checkdevice">
			<mat-icon class="mat-icon-rtl-mirror">share</mat-icon>
			{{ locale.translations['ads']['qrcode']['n408'] }}
		</button>

		<button mat-button class="px-2 px-sm-4 dialog-btn" (click)="downloadBarCode()">
			<mat-icon>save_alt</mat-icon>

			{{ locale.translations['ads']['qrcode']['n409'] }}
		</button>
	</div>
</div>
